import { type FC, type ReactNode } from 'react';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader.js';
import { RecentlyViewedItemsLazy } from 'dibs-recent-history/exports/RecentlyViewedItemsLazy.ts';
import { useRecentlyViewedItemsContext } from 'dibs-recent-history/exports/useRecentlyViewedItemsContext.ts';
import { MOBILE } from 'dibs-recent-history/exports/RecentlyViewedItemsProvider.ts';

import {
    trackViewMoreClick,
    trackItemClick,
    trackItemImpression,
} from 'dibs-recent-history/exports/recentHistoryTracking.ts';
import { trackModule, trackModuleLocation } from '../helpers/moduleLocationTracking.ts';
import { trackInitialDisplay } from '../helpers/carouselTracking.ts';
import { useHomePageContext } from '../HomePageContext.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

const ACTION_LABEL = 'recently viewed';
const TRACKING_TITLE = 'Recently Viewed';

export const HpSharedRecentlyViewedItems: FC<{
    moduleIndex: number;
    totalModules: number;
    loadingComponent?: ReactNode;
    hasBottomSeparator?: boolean;
}> = ({ moduleIndex, totalModules, loadingComponent, hasBottomSeparator }) => {
    const { isBot } = useHomePageContext();
    const { deviceType } = useRecentlyViewedItemsContext();
    const isMobile = deviceType === MOBILE;

    return (
        <>
            <RecentlyViewedItemsLazy
                hasBottomSeparator={hasBottomSeparator || !isMobile}
                authModalLoader={authModalLoader}
                actionLabel={ACTION_LABEL}
                loadingComponent={loadingComponent}
                trackViewMoreClick={trackingProps => {
                    trackViewMoreClick(trackingProps);
                    trackModule(TRACKING_TITLE);
                }}
                trackItemClick={trackingProps => {
                    trackItemClick({ ...trackingProps, variant: 'homepage' });
                    trackModuleLocation({
                        label: 'recently viewed module',
                        moduleIndex,
                        totalModules,
                    });
                    trackModule(TRACKING_TITLE);
                }}
                trackItemImpression={trackingProps => {
                    trackItemImpression({ ...trackingProps, variant: 'homepage' });
                }}
                onInitialDisplay={({ items }) => {
                    trackInitialDisplay({ itemsReturned: items.length, actionLabel: ACTION_LABEL });
                }}
                isBot={isBot}
            />
            {isMobile && (
                <div
                    className={classnames(
                        dibsCss.borderB,
                        dibsCss.borderBSolid,
                        dibsCss.borderBDolphin
                    )}
                />
            )}
        </>
    );
};
